export default "__VITE_PUBLIC_ASSET__cee2bd71__"